import { render, staticRenderFns } from "./StatementCategoriesPage.vue?vue&type=template&id=5b77b04a"
import script from "./StatementCategoriesPage.vue?vue&type=script&lang=js"
export * from "./StatementCategoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports